const reasons = [
  {
    icon: 'ri-star-line',
    title: 'Najlepsze produkty',
    desc: 'Staranne wyselekcjonowane produkty od sprawdzonych sprzedawców, gotowe do zakupu jednym kliknięciem.',
    imageUrl: 'https://readdy.ai/api/search-image?query=Curated%20collection%20of%20premium%20lifestyle%20products%20arranged%20beautifully%20on%20light%20cream%20surface%2C%20featuring%20minimalist%20design%20objects%2C%20warm%20natural%20lighting%2C%20clean%20elegant%20composition%2C%20soft%20shadows%2C%20sophisticated%20modern%20aesthetic%20with%20sage%20green%20accents&width=400&height=300&seq=why-best-products&orientation=landscape',
  },
  {
    icon: 'ri-refresh-line',
    title: 'Aktualne listy',
    desc: 'Regularnie aktualizowane arkusze z najnowszymi produktami, cenami i dostępnością w czasie rzeczywistym.',
    imageUrl: 'https://readdy.ai/api/search-image?query=Modern%20digital%20tablet%20displaying%20organized%20spreadsheet%20data%20on%20clean%20white%20desk%20with%20coffee%20cup%20and%20plant%2C%20bright%20natural%20window%20light%2C%20contemporary%20productive%20workspace%20aesthetic%2C%20cream%20and%20soft%20green%20tones%2C%20sharp%20focus%20on%20screen%20content&width=400&height=300&seq=why-updated-lists&orientation=landscape',
  },
  {
    icon: 'ri-grid-line',
    title: 'Kategorie produktów',
    desc: 'Przejrzysty podział na kategorie ułatwiający szybkie znalezienie dokładnie tego, czego szukasz.',
    imageUrl: 'https://readdy.ai/api/search-image?query=Organized%20retail%20display%20with%20neatly%20grouped%20fashion%20items%20by%20category%20on%20light%20wooden%20shelves%2C%20sneakers%20section%20hoodies%20area%20and%20accessories%20corner%2C%20warm%20boutique%20lighting%2C%20clean%20minimalist%20store%20aesthetic%2C%20cream%20white%20and%20earthy%20tones&width=400&height=300&seq=why-categories&orientation=landscape',
  },
  {
    icon: 'ri-book-open-line',
    title: 'Poradniki zakupowe',
    desc: 'Szczegółowe przewodniki krok po kroku, które pomogą Ci bezpiecznie i sprawnie dokonywać zakupów.',
    imageUrl: 'https://readdy.ai/api/search-image?query=Open%20notebook%20with%20handwritten%20shopping%20notes%20next%20to%20laptop%20on%20warm%20wooden%20desk%2C%20soft%20coffee%20cup%20and%20pen%20nearby%2C%20cozy%20reading%20nook%20atmosphere%2C%20gentle%20morning%20light%2C%20cream%20and%20terracotta%20tones%2C%20calm%20educational%20aesthetic&width=400&height=300&seq=why-guides&orientation=landscape',
  },
  {
    icon: 'ri-shield-check-line',
    title: 'Bezpieczeństwo',
    desc: 'Zweryfikowani sprzedawcy, zdjęcia QC i ochrona kupujących — Twoje zakupy są bezpieczne.',
    imageUrl: 'https://readdy.ai/api/search-image?query=Clean%20modern%20security%20concept%20with%20verified%20badge%20icon%20on%20smartphone%20screen%2C%20placed%20on%20light%20marble%20desk%20with%20small%20succulent%20plant%2C%20soft%20natural%20window%20illumination%2C%20warm%20cream%20white%20tones%2C%20trust%20and%20safety%20themed%20minimalist%20photography&width=400&height=300&seq=why-security&orientation=landscape',
  },
];

export default function WhyChoose() {
  return (
    <section id="guides" className="py-16 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-12">
          <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-950 mb-4">
            Dlaczego warto wybrać Kakobuy Spreadsheet?
          </h2>
          <p className="text-foreground-600 max-w-2xl mx-auto text-sm md:text-base leading-relaxed">
            Poznaj zalety, które sprawiają, że Kakobuy Spreadsheet to najlepsze narzędzie dla świadomych kupujących.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-5">
          {reasons.map((item, i) => (
            <div
              key={item.title}
              className="bg-white rounded-xl border border-background-200/70 hover:border-primary-200 transition-all duration-300 group overflow-hidden animate-[fadeInUp_0.5s_ease-out]"
              style={{ animationDelay: `${i * 0.1}s` }}
            >
              <div className="aspect-[4/3] w-full overflow-hidden">
                <img
                  src={item.imageUrl}
                  alt={item.title}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
              </div>
              <div className="p-5">
                <div className="flex items-center gap-3 mb-3">
                  <div className="w-9 h-9 flex items-center justify-center rounded-lg bg-primary-100 group-hover:bg-primary-200 transition-colors duration-300">
                    <i className={`${item.icon} text-base text-primary-500`}></i>
                  </div>
                  <h3 className="font-semibold text-sm text-foreground-900">{item.title}</h3>
                </div>
                <p className="text-xs text-foreground-500 leading-relaxed">{item.desc}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}